import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=c4fac022&scoped=true"
import script from "./agree.vue?vue&type=script&lang=ts"
export * from "./agree.vue?vue&type=script&lang=ts"
import style0 from "./agree.vue?vue&type=style&index=0&id=c4fac022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fac022",
  null
  
)

export default component.exports